var topFilters = {

    make    : null,
    model   : null,
    year    : null,
    trim    : null,
    init : function (){

        
         $('.top-filters .reset-filters').click(function(){
            window.history.pushState('','Title',window.location.href.split('?')[0]);
            var p = $(this).closest('.partial');
            var s = $('.next-draw');
            
             p.data('page',1);
             p.data("subcategory_id",'');
             p.data("sort_term",'created_at');
             p.data("sort_way",'desc');
             p.data("lakime_featured",'');
             p.data("user_favorites",'');
            
             $('select[name="sort"]').val(null).trigger('change.select2');
             $('select[name="subcategory_id"]').val(null).trigger('change.select2');
             
             Waypoint.refreshAll();
       

             p.addClass('loading');
             if(s.length > 0){
                scroll2element(s.get());  
              }else{
                scroll2element(p.get());
              }
             load_partial(p);
             return false;
        });




        $('.top-filters select.ajax-select').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder,
                    templateResult: formatState,
                     escapeMarkup: function(markup) {
                        return markup;
                      },
                      templateSelection: formatState
                },
                $select_name = $select.attr('name');

            if(data.ajax){
                options = $.extend(false, options , {
                    
                    ajax: {
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            var q = typeof(params.term)!=='undefined'?params.term:''
                            return {
                                route:data.ajax,
                                q: data.search+'=@'+q,
                                current_url : CURRENT_PATH,
                                page: params.page,
                                parent:typeof(data.category_parent!=='undefined')?data.category_parent:''
                            };
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;

                            return { 
                                results: data.data,
                                pagination: {
                                    more: (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    allowClear:false,
                    minimumInputLength: 0
                    
                });

                if($select.data('selected_value')){
                    $.ajax({
                        dataType: 'json',
                        data: {
                            route:data.ajax,
                            id:$select.data('selected_value')
                        },
                        error:function(){},
                        success:function(res){
                            $select.attr('placeholder',res.data[0][data.search]);
                            data.placeholder = res.data[0][data.search];
                            options.placeholder = res.data[0][data.search];

                            $select.html('<option value="'+res.data[0].id+'" selected>'+res.data[0][data.search]+'</option>');
                            $select.select2(options);
                        }
                    });
                }
            }		

            
			
            $(this).select2(options).on('select2:open', function () {
				$(this).closest('.form-group').addClass('filled');
			}).on('select2:close', function () {
				if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
					$(this).closest('.form-group').removeClass('filled');           
				}       
			}).data('select2').$dropdown.addClass('top-filters-container');
			
        });
		
		$('.top-filters select.simple-select').each(function(){
              var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder,
                    templateResult: formatState,
                     escapeMarkup: function(markup) {
                        return markup;
                      },
                      templateSelection: formatState
                },
                $select_name = $select.attr('name');


			$(this).select2().on('select2:open', function () {
				$(this).closest('.form-group').addClass('filled');
			}).on('select2:close', function () {
				if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
					$(this).closest('.form-group').removeClass('filled');           
				}       
			}).select2(options).addClass('top-filters-container');
		});
    }
};


function formatState (state) {

  var icon = $(state.element).data('icon'); 

    if(typeof (icon)==='undefined'){
        if(typeof (state.text)==='undefined'){
             return state.name;   
        }
        return '<span class="select-icon-wrapper">'+state.text+'</span>';
     }else{
          var $state;
         if(typeof (state.text)==='undefined'){
            $state = $('<span class="select-icon-wrapper"><span class="select-icon">'+icon+ '</span><span class="select-label">'+ state.name + '</span><span>');
        }else{
             $state = $('<span class="select-icon-wrapper"><span class="select-icon">'+icon+ '</span><span class="select-label">'+ state.text + '</span><span>');
        }
         
         return $state;
     }
 

};


$(function(){
    topFilters.init();
});	


